export default "__VITE_ASSET__d2383dea__"